/* AirGreen instant search panel. Config comes from snippets/ag-instant-search.liquid (window.AGIS). */
(function () {
  var C = window.AGIS;
  if (!C || window.__agisLoaded) return;
  window.__agisLoaded = true;
  var S = C.s;
  var root = C.root.replace(/\/?$/, '/');
  document.documentElement.classList.add('agis-on');

  // Silence the theme's own predictive dropdown so the two never overlap.
  if (window.customElements) {
    customElements.whenDefined('predictive-search').then(function () {
      var P = customElements.get('predictive-search');
      if (P && P.prototype) { P.prototype.getSearchResults = function () {}; P.prototype.open = function () {}; }
    });
  }

  var ICON_SEARCH = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>';
  var ICON_TAG = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M3 7h18M3 12h18M3 17h12"/></svg>';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) { return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[’']/g, "'"); }
  function fmt(t, o) { return t.replace(/\{(\w+)\}/g, function (_, k) { return o[k]; }); }
  function money(n) { n = Math.round(+n); return C.en ? '$' + n.toLocaleString('en-CA') : n.toLocaleString('fr-CA').replace(/\s/g, ' ') + ' $'; }
  function num(n) { return String(n).replace('.', C.en ? '.' : ','); }

  // Titles carry SEO city lists ("| Montréal, Laval, ..."); the panel shows the product name only.
  var CITY = /\s*(?:[|,–-]\s*|(?:^|\s)(?:à|a|au|dans le|partout dans le|partout à|installation à|in|across)\s+)?(?:le\s+)?(?:grand\s+)?(?:montr[ée]al|laval|longueuil|rive[- ]sud|rive[- ]nord|south shore|north shore|greater montreal)\b[\s\S]*$/i;
  function shortTitle(t) {
    var s = String(t || '').replace(/^installation\s+(?:d['e]\s*(?:une?\s+)?)?/i, '');
    var cut = s.replace(CITY, '').replace(/[\s|,–-]+$/, '');
    if (cut.length < 8) cut = s;
    return cut.charAt(0).toUpperCase() + cut.slice(1);
  }

  var panel, body, footer, activeInput, timer, seq = 0, cache = {}, items = [], idx = -1;

  function build() {
    panel = document.createElement('div');
    panel.className = 'agis';
    panel.hidden = true;
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', S.sugg);
    panel.innerHTML = '<div class="agis-load"></div><div class="agis-body" id="agis-body"></div><div class="agis-f"></div>';
    body = panel.querySelector('.agis-body');
    footer = panel.querySelector('.agis-f');
    document.body.appendChild(panel);
    panel.addEventListener('mousedown', function (e) { if (!e.target.closest('a')) e.preventDefault(); });
    panel.addEventListener('click', function (e) {
      if (e.target.closest('[data-submit]')) { e.preventDefault(); submit(); }
    });
  }

  function place() {
    if (!activeInput || panel.hidden) return;
    var anchor = activeInput.closest('form') || activeInput;
    var r = anchor.getBoundingClientRect();
    var vw = document.documentElement.clientWidth, vh = window.innerHeight;
    var mobile = vw < 760;
    var w = mobile ? vw - 16 : Math.min(980, vw - 24);
    var left = mobile ? 8 : Math.max(12, Math.min(r.left + r.width / 2 - w / 2, vw - w - 12));
    if (!mobile && r.width > w * 0.6) left = Math.max(12, Math.min(r.left, vw - w - 12));
    var top = Math.max(8, r.bottom + 8);
    panel.style.left = left + 'px';
    panel.style.top = top + 'px';
    panel.style.width = w + 'px';
    panel.style.maxHeight = Math.max(260, vh - top - 12) + 'px';
  }

  function open() { panel.hidden = false; place(); if (activeInput) activeInput.setAttribute('aria-expanded', 'true'); }
  function close() { if (!panel || panel.hidden) return; panel.hidden = true; idx = -1; if (activeInput) activeInput.setAttribute('aria-expanded', 'false'); }

  function submit() {
    var f = activeInput && activeInput.closest('form');
    if (f) { if (f.requestSubmit) f.requestSubmit(); else f.submit(); }
    else location.href = root + 'search?q=' + encodeURIComponent(activeInput.value);
  }

  function hl(text, q) {
    var n = norm(text), nq = norm(q).trim(), i = n.indexOf(nq);
    if (!nq || i < 0) return '<b>' + esc(text) + '</b>';
    return '<b>' + esc(text.slice(0, i)) + '</b>' + esc(text.slice(i, i + nq.length)) + '<b>' + esc(text.slice(i + nq.length)) + '</b>';
  }

  function suggestionRow(q, label, count) {
    return '<a class="agis-s agis-i" href="' + root + 'search?q=' + encodeURIComponent(q) + '"><span>' + ICON_SEARCH + '<span>' + label + '</span></span>' + (count ? '<small>' + count + '</small>' : '') + '</a>';
  }

  function helpBlock(list) {
    if (!list.length) return '';
    return '<div><div class="agis-h">' + S.help + '</div><div class="agis-help">' + list.map(function (h) {
      return '<a class="agis-i" href="' + esc(h.u) + '"><b>' + esc(h.t) + '</b>' + esc(h.d || '') + '</a>';
    }).join('') + '</div></div>';
  }

  function staticLinks(q) {
    var nq = norm(q);
    return C.links.filter(function (l) { return !q || new RegExp(l[3]).test(nq); }).map(function (l) { return { t: l[0], d: l[1], u: root + l[2] }; });
  }

  function productCard(p) {
    var chips = [];
    if (p.btu) chips.push(esc(p.btu) + ' BTU');
    if (p.seer) chips.push('SEER ' + num(p.seer));
    if (p.cold !== null && p.cold !== undefined && p.cold !== '') chips.push(esc(p.cold) + ' °C');
    if (p.wifi && /inclus|included|oui|yes/i.test(p.wifi)) chips.push('Wi-Fi');
    var stars = '';
    if (p.r) { var f = Math.round(+p.r); stars = '<div class="agis-st"><i>' + '★★★★★'.slice(0, f) + '☆☆☆☆☆'.slice(0, 5 - f) + '</i> ' + num((+p.r).toFixed(1)) + (p.rc ? ' (' + p.rc + ' ' + S.rev + ')' : '') + '</div>'; }
    return '<a class="agis-pc agis-i" href="' + esc(p.u) + '">' +
      '<span class="im">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="64" height="64">' : '') + '</span>' +
      '<span class="tx"><span class="br">' + esc(p.v) + '</span><span class="ti">' + esc(shortTitle(p.t)) + '</span>' + stars +
      (chips.length ? '<span class="agis-ch">' + chips.slice(0, 3).map(function (c) { return '<span>' + c + '</span>'; }).join('') + '</span>' : '') +
      (+p.sub > 0 ? '<span class="agis-sub">' + fmt(S.sub, { n: money(p.sub) }) + '</span>' : '') +
      '</span></a>';
  }

  function cleanUrl(u) {
    try { var x = new URL(u, location.origin); x.searchParams.delete('view'); x.searchParams.delete('page'); return x.pathname + x.search; } catch (e) { return u; }
  }

  function renderEmpty() {
    body.innerHTML =
      '<div class="agis-l"><div><div class="agis-h">' + S.pop + '</div><div class="agis-list">' +
      C.pop.map(function (q) { return suggestionRow(q, '<b>' + esc(q) + '</b>'); }).join('') + '</div></div></div>' +
      '<div class="agis-r"><div><div class="agis-h">' + S.quick + '</div><div class="agis-help">' +
      C.quick.map(function (c) { return '<a class="agis-i" href="' + root + c[1] + '"><b>' + esc(c[0]) + '</b></a>'; }).join('') + '</div></div>' +
      helpBlock(staticLinks('').slice(0, 3)) + '</div>';
    footer.innerHTML = '<span class="agis-k"><kbd>↑</kbd> <kbd>↓</kbd> ' + S.nav + ' · <kbd>Entrée</kbd> ' + S.open + '</span>';
    if (C.en) footer.innerHTML = footer.innerHTML.replace('Entrée', 'Enter');
    collect();
  }

  function render(q, d) {
    var nq = norm(q).trim();
    var sugg = [], seen = {};
    function addS(s) { var k = norm(s); if (!seen[k] && k !== nq) { seen[k] = 1; sugg.push(s); } }
    (d.queries || []).forEach(function (x) { addS(x.text); });
    C.vocab.forEach(function (v) { var n = norm(v); if (n.indexOf(nq) === 0 || n.indexOf(' ' + nq) > -1) addS(v); });
    sugg = sugg.slice(0, 6);
    var types = pickTypes(q, d.types);
    var tl = types.map(function (t) { return norm(t.l); });
    var cols = (d.collections || []).filter(function (c) { return tl.indexOf(norm(shortTitle(c.title))) < 0 && !tl.some(function (x) { return norm(c.title).indexOf(x) === 0; }); }).slice(0, 3);
    var help = (d.pages || []).concat(d.articles || []).slice(0, 2).map(function (p) { return { t: p.title, d: '', u: p.url }; });
    help = staticLinks(q).concat(help).slice(0, 4);

    var left = '';
    if (sugg.length) left += '<div><div class="agis-h">' + S.sugg + '</div><div class="agis-list">' + sugg.map(function (s) { return suggestionRow(s, hl(s, q)); }).join('') + '</div></div>';
    if (types.length || cols.length) {
      left += '<div><div class="agis-h">' + S.cats + '</div><div class="agis-list">' +
        types.map(function (t) { return '<a class="agis-s agis-i" href="' + esc(cleanUrl(t.u)) + '"><span>' + ICON_TAG + '<span>' + S.in + ' <b>' + esc(t.l) + '</b></span></span><small>' + t.c + '</small></a>'; }).join('') +
        cols.map(function (c) { return '<a class="agis-s agis-i" href="' + esc(c.url) + '"><span>' + ICON_TAG + '<span><b>' + esc(shortTitle(c.title)) + '</b></span></span></a>'; }).join('') +
        '</div></div>';
    }
    if (!left) left = '<div><div class="agis-h">' + S.pop + '</div><div class="agis-list">' + C.pop.map(function (p) { return suggestionRow(p, '<b>' + esc(p) + '</b>'); }).join('') + '</div></div>';

    var right = '';
    if (d.products.length) {
      right += '<div><div class="agis-h">' + S.prods + '</div><div class="agis-p">' + d.products.map(productCard).join('') + '</div></div>';
    } else {
      right += '<div class="agis-empty"><b>' + fmt(S.none, { q: esc(q) }) + '</b>' + S.noneTip + '</div>';
      help = [{ t: S.talk, d: S.talkTip, u: root + 'pages/contactez-nous' }].concat(help.filter(function (h) { return !/contactez-nous/.test(h.u); })).slice(0, 4);
    }
    right += helpBlock(help);
    body.innerHTML = '<div class="agis-l">' + left + '</div><div class="agis-r">' + right + '</div>';
    footer.innerHTML = '<span class="agis-k"><kbd>↑</kbd> <kbd>↓</kbd> ' + S.nav + '</span>' +
      (d.products.length ? '<a class="agis-all agis-i" href="' + root + 'search?q=' + encodeURIComponent(q) + '" data-submit>' + (d.count && d.count < 1000 ? fmt(S.all, { n: d.count }) : fmt(S.allq, { q: esc(q) })) + '</a>' : '');
    collect();
  }

  function collect() { items = Array.prototype.slice.call(panel.querySelectorAll('.agis-i')); idx = -1; }
  function move(dir) {
    if (!items.length) return;
    if (idx > -1) items[idx].classList.remove('agis-a');
    idx += dir;
    if (idx >= items.length) idx = -1;
    else if (idx < -1) idx = items.length - 1;
    if (idx > -1) { items[idx].classList.add('agis-a'); items[idx].scrollIntoView({ block: 'nearest' }); }
  }

  function getJSON(url) { return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (t) { return JSON.parse(t.trim()); }); }

  // Shopify answers a query it can't match with unrelated products; keep results only when one actually relates to the query.
  // English and French stems, both ways, so a French word typed on the English site (or the reverse) still counts.
  var ALT = { heat: 'thermo', ther: 'heat', pump: 'pomp', pomp: 'pump', dehu: 'deshu', desh: 'dehu', exch: 'echan', echa: 'exch', cond: 'clim', clim: 'cond', furn: 'fourn', four: 'furn', wall: 'mura', mura: 'wall', mini: 'mura', subv: 'rebat', reba: 'subv', gran: 'subv' };
  function qtoks(q) {
    var toks = norm(q).split(/[^a-z0-9]+/).filter(function (t) { return t.length > 1; });
    return toks.concat(toks.map(function (t) { return ALT[t.slice(0, 4)] || ''; }).filter(Boolean));
  }
  function hits(hay, toks) {
    hay = norm(hay).replace(/[^a-z0-9]+/g, '');
    return toks.filter(function (t) { return hay.indexOf(t.slice(0, Math.min(4, t.length))) > -1; }).length;
  }
  function relevant(q, products, count) {
    if (count && count < 900) return products;
    var toks = qtoks(q);
    if (!toks.length) return products;
    // p.u carries the product handle, which stays in French on the English site.
    var hit = products.some(function (p) { return hits([p.t, p.v, p.pt, p.u].join(' '), toks) > 0; });
    return hit ? products : [];
  }
  // Product types that match the query words come first; with no match (a brand or model number), the biggest types.
  function pickTypes(q, types) {
    var toks = qtoks(q);
    var scored = (types || []).map(function (t) { return { t: t, s: hits(t.l, toks) }; });
    var matched = scored.filter(function (x) { return x.s > 0; });
    var list = matched.length ? matched : scored;
    return list.sort(function (a, b) { return (b.s - a.s) || (b.t.c - a.t.c); }).map(function (x) { return x.t; }).slice(0, matched.length ? 4 : 3);
  }

  function run() {
    var q = activeInput.value.trim();
    clearTimeout(timer);
    if (!q) { renderEmpty(); open(); panel.classList.remove('is-loading'); return; }
    if (q.length < 2) return;
    var key = q.toLowerCase();
    if (cache[key]) { render(q, cache[key]); open(); return; }
    timer = setTimeout(function () {
      var my = ++seq;
      panel.classList.add('is-loading');
      var enc = encodeURIComponent(q);
      var pA = getJSON(root + 'search?q=' + enc + '&type=product&options%5Bprefix%5D=last&view=ag-instant').catch(function () { return { count: 0, products: [], types: [] }; });
      var pB = getJSON(root + 'search/suggest.json?q=' + enc + '&resources%5Btype%5D=query,collection,page,article&resources%5Blimit%5D=4&resources%5Boptions%5D%5Bprefix%5D=last')
        .then(function (j) { return (j.resources && j.resources.results) || {}; }).catch(function () { return {}; });
      Promise.all([pA, pB]).then(function (r) {
        var prods = relevant(q, r[0].products || [], r[0].count);
        var d = { count: prods.length ? r[0].count : 0, products: prods, types: prods.length ? r[0].types : [], queries: r[1].queries, collections: r[1].collections, pages: r[1].pages, articles: r[1].articles };
        cache[key] = d;
        if (my !== seq || !activeInput || activeInput.value.trim().toLowerCase() !== key) return;
        panel.classList.remove('is-loading');
        render(q, d); open();
      });
    }, 160);
  }

  function isTarget(el) {
    return el && el.tagName === 'INPUT' && el.name === 'q' && el.closest('form[action*="/search"]') && !el.closest('#MainContent');
  }

  function bind(input) {
    if (input.__agis) return;
    input.__agis = true;
    input.setAttribute('autocomplete', 'off');
    input.addEventListener('input', function () { activeInput = input; run(); });
    input.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); e.stopPropagation(); move(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); e.stopPropagation(); move(-1); }
      else if (e.key === 'Escape') { close(); }
      else if (e.key === 'Enter' && idx > -1 && items[idx]) {
        e.preventDefault(); e.stopPropagation();
        var a = items[idx];
        if (a.hasAttribute('data-submit')) submit();
        else location.href = a.href;
      }
    }, true);
  }

  function init() {
    build();
    document.addEventListener('focusin', function (e) {
      if (isTarget(e.target)) { bind(e.target); activeInput = e.target; run(); }
    });
    document.addEventListener('mousedown', function (e) {
      if (panel.hidden) return;
      if (panel.contains(e.target) || (activeInput && (e.target === activeInput || (activeInput.closest('form') || {}).contains && activeInput.closest('form').contains(e.target)))) return;
      close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    window.addEventListener('resize', place);
    window.addEventListener('scroll', place, { passive: true });
    var a = document.activeElement;
    if (isTarget(a)) { bind(a); activeInput = a; run(); }
    // Deep link: airgreen.ca/#agis=thermo opens the panel with that search.
    var m = location.hash.match(/^#agis=(.*)$/);
    if (m) {
      var inp = Array.prototype.filter.call(document.querySelectorAll('input[name="q"]'), function (i) { return isTarget(i) && i.offsetParent; })[0];
      if (inp) { bind(inp); activeInput = inp; inp.value = decodeURIComponent(m[1]); run(); }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
